<template>
  <div>
    <div class="row">
      <div class="col-6">
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-header header-elements-inline">
                <h5 class="card-title">Payroll Settings</h5>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-lg-6 col-md-4 col-sm-12">
                    <div class="form-group">
                      <label>First Day of Week:</label>
                      <!-- this needs to be a ddl of employees -->
                      <v-select
                        :options="daysOfWeek"
                        label="firstDay"
                        v-model="selectedDayOfWeek"
                      ></v-select>
                    </div>
                  </div>
                </div>
                <div class="row alignRowBottom">
                  <div class="col-lg-6 col-md-4 col-sm-12">
                    <div class="form-group">
                      <label>Pay Period:</label>
                      <!-- this needs to be a ddl of employees -->
                      <v-select
                        :options="payPeriods"
                        label="payPeriod"
                        v-model="selectedPayPeriod"
                      ></v-select>
                    </div>
                  </div>
                  <div class="col-lg-6 col-sm-12">
                    <button
                      type="button"
                      class="btn btn-primary float-right"
                      v-on:click="updatePayroll"
                    >
                      Update
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-header header-elements-inline">
                <h5 class="card-title">Organization Settings</h5>
              </div>
              <div class="card-body">
                <div class="row alignRowBottom">
                  <div class="col-lg-6 col-md-4 col-sm-12">
                    <div class="form-group">
                      <label>Round Time Cards:</label>
                      <!-- this needs to be a ddl of employees -->
                      <v-select
                        :options="roundingOptions"
                        label="payPeriod"
                        v-model="selectedRoundingOption"
                      ></v-select>
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-4 col-sm-12">
                    <div class="form-group">
                      <label>Show On Call Notification:</label>
                      <!-- this needs to be a ddl of employees -->
                      <v-select
                        :options="notifyOnCallOptions"
                        label="onCallNotification"
                        v-model="selectedNotifyOnCall"
                      ></v-select>
                    </div>
                  </div>
                </div>
                <div class="row alignRowBottom">
                  <div class="col-lg-6 col-md-4 col-sm-12">
                    <div class="form-group">
                      <label>Show Incomplete Time Cards:</label>
                      <!-- this needs to be a ddl of employees -->
                      <v-select
                        :options="showIncompleteTimeCardsOptions"
                        label="payPeriod"
                        v-model="selectedShowsIncompleteTimeCards"
                      ></v-select>
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-4 col-sm-12">
                    <div class="form-group">
                      <label>Show Inactive Employees:</label>
                      <!-- this needs to be a ddl of employees -->
                      <v-select
                        :options="showInactiveEmployeesOptions"
                        label="inactiveEmplyees"
                        v-model="selectedShowInactiveEmployees"
                      ></v-select>
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-4 col-sm-12">
                    <div class="form-group">
                      <label>Require Edit Comments:</label>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        placement="top"
                        data-html="true"
                      >
                        <div slot="content">
                          Require users to leave a comment each time they edit a
                          time card or create a time card.
                        </div>
                        <i class="icon-info22 ml-2 infoIcon"></i>
                      </el-tooltip>
                      <!-- this needs to be a ddl of employees -->
                      <v-select
                        :options="editCommentsOptions"
                        label="inactiveEmplyees"
                        v-model="editComments"
                      ></v-select>
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-4 col-sm-12">
                    <div class="form-group">
                      <label>Set all employees as 5 of 9:</label>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        placement="top"
                        data-html="true"
                      >
                        <div slot="content">
                          Set all employees to use the 5 of 9 rule when it comes
                          to calculating stat pay
                        </div>
                        <i class="icon-info22 ml-2 infoIcon"></i>
                      </el-tooltip>
                      <!-- this needs to be a ddl of employees -->
                      <v-select
                        :options="fiveOfNineOptions"
                        label="fiveOfNine"
                        v-model="fiveOfNine"
                      ></v-select>
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-4 col-sm-12">
                    <div class="form-group">
                      <label>Count OT Exempt Time In Stat Pay:</label>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        placement="top"
                        data-html="true"
                      >
                        <div slot="content">
                          Includes or excludes OT exempt times in stat pay
                          calculation
                        </div>
                        <i class="icon-info22 ml-2 infoIcon"></i>
                      </el-tooltip>
                      <v-select
                        :options="statCountsOTExemptOptions"
                        label="statCountsOTExempt"
                        v-model="statCountsOTExempt"
                      ></v-select>
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-4 col-sm-12">
                    <div class="form-group">
                      <label>Enable Job Specific Times:</label>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        placement="top"
                        data-html="true"
                      >
                        <div slot="content">
                          Allows users to assign times to different customers,
                          so you can calculate pay differently based on
                          different customers
                        </div>
                        <i class="icon-info22 ml-2 infoIcon"></i>
                      </el-tooltip>
                      <v-select
                        :options="jobSpecificTimesOptions"
                        label="jobSpecificTimes"
                        v-model="jobSpecificTimes"
                      ></v-select>
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-4 col-sm-12">
                    <div class="form-group">
                      <label>Allow notification:</label>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        placement="top"
                        data-html="true"
                      >
                        <div slot="content">
                          Notifications reminding to log out after exceeding the
                          number of hours.
                        </div>
                        <i class="icon-info22 ml-2 infoIcon"></i>
                      </el-tooltip>
                      <v-select
                        :options="allowNotifications"
                        label="logoutNotification"
                        v-model="selectedAllowNotifications"
                      ></v-select>
                    </div>
                  </div>
                  <div class="col-lg-12 col-sm-12">
                    <button
                      type="button"
                      class="btn btn-primary float-right"
                      v-on:click="updateOrg"
                      title="Popover Title"
                    >
                      Update
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row hidden">
          <div class="col-12">
            <div class="card">
              <div class="card-header header-elements-inline">
                <h5 class="card-title">Employee Categories</h5>
              </div>
              <div class="card-body">
                <div class="row alignRowBottom">
                  <table class="table table-striped">
                    <thead>
                      <tr>
                        <td></td>
                        <td>Category</td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(category, index) in employeeCategories"
                        v-bind:key="`category_${index}`"
                      >
                        <td></td>
                        <td>
                          {{ category.name }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="col-lg-12 col-sm-12">
                    <button
                      type="button"
                      class="btn btn-primary float-right"
                      v-on:click="updateOrg"
                      title="Popover Title"
                    >
                      Update
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-header header-elements-inline">
                <h5 class="card-title">Company Logo</h5>
              </div>
              <div class="card-body">
                <el-upload
                  class="company-logo"
                  :multiple="false"
                  :limit="1"
                  drag
                  action=""
                  :http-request="uploadLogo"
                  :on-remove="handleLogoRemove"
                  :file-list="fileList"
                  list-type="picture-card"
                  accept=".jpg,.png"
                >
                  <i slot="default" class="el-icon-plus"></i>
                  <div slot="tip" class="card-title mt-3 ">
                    Logos must be jpg/png files with a size less than 500KB.
                  </div>
                </el-upload>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-header header-elements-inline">
                <h5 class="card-title">Holidays</h5>
              </div>
              <div class="card-body">
                <table class="table table-striped">
                  <tr>
                    <th>
                      Name
                    </th>
                    <th>
                      Date
                    </th>
                  </tr>
                  <tr v-for="(holiday, index) in holidays" v-bind:key="index">
                    <td>
                      {{ holiday.nameEn }}
                    </td>
                    <td>
                      {{ formatDate(holiday.date) }}
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { db, storage } from '../assets/js/firebase/db.js';
import moment from 'moment';
import { mapState } from 'vuex';
import { getHolidays } from '../assets/js/helpers/holidays.js';
import { getBase64ImageFromURL } from '../assets/js/helpers/uriEncoder.js';
export default {
  name: 'settings',
  data() {
    return {
      daysOfWeek: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
      ],
      selectedDayOfWeek: null,
      payPeriods: ['Weekly', 'Every two weeks', 'Twice a month', 'Monthly'],
      selectedPayPeriod: null,
      roundingOptions: ['No', '1/4 Hour', '1/2 Hour'],
      selectedRoundingOption: null,
      showIncompleteTimeCardsOptions: ['No', 'Yes'],
      selectedShowsIncompleteTimeCards: null,
      notifyOnCallOptions: ['No', 'Yes'],
      selectedNotifyOnCall: null,
      showInactiveEmployeesOptions: ['No', 'Yes'],
      selectedShowInactiveEmployees: null,
      editComments: null,
      fiveOfNine: null,
      fiveOfNineOptions: ['No', 'Yes'],
      statCountsOTExempt: null,
      editCommentsOptions: ['Yes', 'No'],
      statCountsOTExemptOptions: ['Yes', 'No'],
      jobSpecificTimes: null,
      jobSpecificTimesOptions: ['Yes', 'No'],
      holidays: [],
      fileList: [],
      employeeCategories: [],
      allowNotifications: ['No', 'Yes'],
      selectedAllowNotifications: null
    };
  },
  methods: {
    formatDate: function(date) {
      return moment(date).format('MMM DD, YY');
    },
    updateOrg: function() {
      this.updateSettings({
        timeCardRounding: this.selectedRoundingOption,
        showIncompleteTimeCards: this.selectedShowsIncompleteTimeCards,
        showOnCallNotification: this.selectedNotifyOnCall,
        showInactiveEmployees: this.selectedShowInactiveEmployees,
        editComments: this.editComments,
        fiveOfNine: this.fiveOfNine,
        statCountsOTExempt: this.statCountsOTExempt,
        jobSpecificTimes: this.jobSpecificTimes,
        allowNotifications: this.selectedAllowNotifications
      });
    },
    updatePayroll: function() {
      this.updateSettings({
        firstDay: this.selectedDayOfWeek,
        payPeriod: this.selectedPayPeriod
      });
    },
    updateSettings: function(updateItems) {
      try {
        let globalState = this;
        db.collection('companySettings')
          .where('company', '==', this.userCompany)
          .get()
          .then(querySnapshot => {
            let id;
            querySnapshot.forEach(doc => {
              id = doc.id;
            });
            db.collection('companySettings')
              .doc(id)
              .update(updateItems)
              .then(() => {
                //udpate the settings in the store.
                this.$store.commit('updateCompanySettings', {
                  rounding: this.selectedRoundingOption,
                  incomplete: this.selectedShowsIncompleteTimeCards,
                  oncall: this.selectedNotifyOnCall,
                  inactiveEmployees: this.selectedShowInactiveEmployees,
                  editComments: this.editComments,
                  fiveOfNine: this.fiveOfNine,
                  statCountsOTExempt: this.statCountsOTExempt,
                  jobSpecificTimes: this.jobSpecificTimes,
                  notificationAllowed: this.selectedAllowNotifications
                });
                this.showSuccess('Settings updated.');
              })
              .catch(err => {
                console.log(`Error updating settings: ${err}`);
                this.showError('Error updating settings.');
              });
          })
          .catch(err => {
            console.log(`Error getting company settings id: ${err}`);
            this.showError('Error getting company settings id');
          });
      } catch (err) {
        console.log(`Unexpected error updating company settings: ${err}`);
        this.showError('Unexpected error updating company settings.');
      }
    },
    showSuccess: function(message) {
      this.$toasted.show(message, {
        duration: '5000',
        keepOnHover: true,
        type: 'success'
      });
    },
    showError: function(message) {
      this.$toasted.show(message, {
        duration: '5000',
        keepOnHover: true,
        type: 'error'
      });
    },
    handleLogoRemove(file, fileList) {
      console.log(file, fileList);
    },
    uploadLogo: function(file) {
      //TODO: check that the image is under 500KB.
      console.log(file);
      if (file.file.size < 500000) {
        //show the use that the logo is currently being uploaded.
        let uploadToast = this.$toasted.show('Logo uploading...', {
          // duration: '5000',
          keepOnHover: true,
          type: 'info'
        });
        //upload the logo to firebase cloud storage.
        try {
          let storageRef = storage.ref(
            `logos/${this.$store.state.userCompany}`
          );
          storageRef
            .put(file.file)
            .then(response => {
              //update the company logo in the store so it is accessible throughout the site.
              //get the download url so we can encode it for the store.
              response.ref.getDownloadURL().then(url => {
                getBase64ImageFromURL(url)
                  .then(resp => {
                    this.$store.commit('updateLogoMetaData', {
                      url: url,
                      base64: resp
                    });
                    uploadToast.goAway(0);
                    this.$toasted.show(`Logo uploaded successfully.`, {
                      duration: '5000',
                      keepOnHover: true,
                      type: 'success'
                    });
                  })
                  .catch(urlErr => {
                    console.log(urlErr);
                    console.log('Error uploading company logo');
                  });
              });
            })
            .catch(err => {
              uploadToast.goAway(0);
              this.$toasted.show(`Error uploading file: ${err}`, {
                // duration: '5000',
                keepOnHover: true,
                type: 'error'
              });
            });
        } catch (err) {
          uploadToast.goAway(0);
          this.$toasted.show(`Error uploading file: ${err}`, {
            // duration: '5000',
            keepOnHover: true,
            type: 'error'
          });
        }
      } else {
        this.fileList = [];
        this.$toasted.show(`File is too large.`, {
          duration: '3000',
          keepOnHover: true,
          type: 'error'
        });
      }
    },
    getCompanyLogo: function() {
      //if we have a value for the company logo in the store, populate the list.
      if (
        this.$store.state.logoUrl != null &&
        this.$store.state.encodedLogo != null
      ) {
        this.fileList.push({
          name: this.$store.state.userCompany,
          url: this.$store.state.logoUrl
        });
      }
    },
    getEmployeeCategories: function() {
      //get the employee categories
      db.collection('employeeCategories')
        .where('org', '==', this.$store.state.userCompany)
        .orderBy('name', 'asc')
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            this.employeeCategories.push({
              name: doc.data().name
            });
          });
        })
        .catch(err => {
          console.log(`Error getting employee categories: ${err}`);
          this.showError('Error getting employee categories');
        });
    }
  },
  computed: mapState(['userCompany']),
  mounted() {
    db.collection('companySettings')
      .where('company', '==', this.userCompany)
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          this.company = doc.data().company;
          this.selectedDayOfWeek = doc.data().firstDay;
          this.selectedPayPeriod = doc.data().payPeriod;
          this.selectedRoundingOption = doc.data().timeCardRounding;
          this.selectedShowsIncompleteTimeCards = doc.data().showIncompleteTimeCards;
          this.selectedNotifyOnCall = doc.data().showOnCallNotification;
          this.selectedShowInactiveEmployees = doc.data().showInactiveEmployees;
          this.editComments = doc.data().editComments;
          this.fiveOfNine = doc.data().fiveOfNine;
          this.statCountsOTExempt = doc.data().statCountsOTExempt;
          this.jobSpecificTimes = doc.data().jobSpecificTimes;
          this.selectedAllowNotifications =
            doc.data().allowNotifications || false;
        });
      })
      .catch(err => {
        console.log(`Error getting company settings: ${err}`);
        this.showError('Error getting company settings');
      });
    this.getEmployeeCategories();
    //get the list of holidays.
    getHolidays()
      .then(response => {
        //console.log(response)
        this.holidays = response.data.provinces[0].holidays;
      })
      .catch(err => {
        console.log(`Error calling the get holidays function: ${err}`);
        this.showError('Error calling the get holidays function.');
      });
    this.getCompanyLogo();
  }
};
</script>

<style>
.el-upload__input {
  display: none !important;
}
</style>
